import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/70 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Vigorbuy<span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-xs text-foreground-500 leading-relaxed">
              The ultimate product research database. Helping shoppers discover, compare and understand products through organized spreadsheets.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Home</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Shopping Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-safety-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Safety Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-beginner-tutorial" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Beginner Tutorial</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Main Website</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Shoes</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Hoodies / Sweaters</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Jackets</a></li>
              <li><a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Accessories</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">SEO Articles</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Complete Guide 2026</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-safety-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Safety & Security</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-category-comparison" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Category Comparison</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-beginner-tutorial" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Beginner Tutorial</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">Vigorbuy Spreadsheet</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">Terms</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}